"use client";

import RouteErrorBoundary from "@/components/RouteErrorBoundary";

export default function AppError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <RouteErrorBoundary {...props} source="app.error.boundary" />;
}
